import { GetFavoriteOrdersResponse, useGetFavoriteOrdersMutation } from '@services';
import { useEffect, useMemo, useState } from 'react';

export const useFavoriteOrdersPageVM = () => {
    const [orders, setOrders] = useState<GetFavoriteOrdersResponse>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [searchTerm, setSearchTerm] = useState<string>('');

    const [getFavoriteOrders, { data, isLoading, isError }] = useGetFavoriteOrdersMutation();

    useEffect(() => {
        getFavoriteOrders(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data) {
            setOrders(data);
        }

        if (isError) {
            setErrorMessage('Une erreur est survenue lors du chargement des commandes favorites');
        }
    }, [data, isLoading, isError]);

    const filteredOrders = useMemo(() => {
        if (!searchTerm.trim()) {
            return orders;
        }
        return orders.filter(
            (order) =>
                order.id.toString().includes(searchTerm.toLowerCase()) || order.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [orders, searchTerm]);

    return {
        orders: filteredOrders,
        isLoading,
        errorMessage,
        searchTerm,
        setSearchTerm
    };
};
